// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.otp-step[data-v-36a959d0] {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.otp-guide[data-v-36a959d0] {
  margin: 0;
  color: #2f3337;
  font-size: 0.875rem;
  line-height: 1.5;
}
.otp-row[data-v-36a959d0] {
  display: flex;
  gap: 8px;
}
.otp-code[data-v-36a959d0] {
  flex: 1;
}
.otp-resend[data-v-36a959d0] {
  flex: none;
  min-width: 116px;
  height: 40px;
  color: #2f3337;
}

/* 수단 고르기: 줄을 채우는 두 칸(글자 길이만큼 기본 폭, 좁은 로그인 카드에서도 한 줄). 선택된 칸은 앱 주 색(노랑) 바탕에 진한 글자(D8) */
.otp-methods[data-v-36a959d0] {
  display: flex;
  width: 100%;
}
.otp-methods[data-v-36a959d0] .ant-radio-button-wrapper {
  flex: 1 1 auto;
  padding: 0 12px;
  white-space: nowrap;
  height: 40px;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  color: #4b5158 !important;
}
.otp-methods[data-v-36a959d0] .ant-radio-button-wrapper span {
  color: inherit !important;
}
.otp-methods[data-v-36a959d0]
  
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)
   {
  border-color: #ffcc32 !important;
  background: #ffcc32 !important;
  color: #17191c !important;
  font-weight: 700;
}
.otp-methods[data-v-36a959d0]
  
    .ant-radio-button-wrapper-checked:not(
        .ant-radio-button-wrapper-disabled
      )::before
   {
  background-color: #ffcc32 !important;
}
.otp-methods[data-v-36a959d0] .ant-radio-button-wrapper:focus-within {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.15) !important;
}
.otp-error[data-v-36a959d0] {
  margin: 0;
  color: #b23a3a;
  font-size: 0.875rem;
  line-height: 1.5;
}
.otp-help[data-v-36a959d0] {
  margin: 0;
  color: #5c6168;
  font-size: 12px;
  line-height: 1.5;
}
.otp-primary[data-v-36a959d0] {
  height: 44px;
  font-weight: 700;
}
[data-v-36a959d0] .yellow-button {
  background-color: #ffcc32 !important;
  border-color: #ffcc32 !important;
  color: #17191c !important;
}
[data-v-36a959d0] .yellow-button:hover {
  background-color: #e6b82e !important;
  border-color: #e6b82e !important;
}
[data-v-36a959d0] .yellow-button:disabled {
  background-color: #e8ebed !important;
  border-color: #e8ebed !important;
  color: #4b5158 !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
